import { Capability } from 'src/types/user';
import { useMe } from './use-context';

export const useCapabilities = (...capabilities: Capability[]) => {
  const me = useMe();

  return capabilities.map(
    (capability) => me.tenantAdmin || me.capabilities.includes(capability)
  );
};
